import {
	createStyles,
} from '@mui/styles';
import {
	alpha,
	Theme,
} from '@mui/material/styles';

const styles = (theme: Theme) => {

	const btnRootBaseStyles: any = {
		fontSize: '0.9em',
		cursor: 'pointer',
		textDecoration: 'none',
		margin: '0',
		padding: '10px',
		textTransform: 'none',
		minWidth: '0px',
		borderRadius: '0px',
		color: theme.palette.info.main,
	};

	const linkRootBaseStyles: any = {
		cursor: 'pointer',
		textDecoration: 'none',
		margin: '0',
		textTransform: 'none',
		minWidth: '0px',
		borderRadius: '0px',
		padding: '10px',
		width: '100%',
		color: theme.palette.info.main,
	};

	return createStyles({
		CATNavBar_body: {
			display: 'flex',
			flexDirection: 'row',
			flex: '1 0 auto !important',
			justifyContent: 'start',
		},
		CATNavBar_linksList: {
			overflowX: 'hidden',
			overflowY: 'hidden',
			width: '0px',
			marginRight: '30px',
			display: 'flex',
			flexDirection: 'row',
			flex: '1 0 auto !important',
			justifyContent: 'flex-end',
		},
		CATNavBar_linksLbl: {
			whiteSpace: 'nowrap'
		},
		CATNavBar_btnWrapper: {
			display: 'flex',
		},
		CATNavBar_btnRoot: {
			background: 'none',
			boxShadow: 'none',
			whiteSpace: 'nowrap',
			'&:hover': {
				boxShadow: 'none',
				background: 'none'
			},
			...btnRootBaseStyles
		},
		CATNavBar_btnRootHighLight: {
			background: theme.palette.grey[100],
			boxShadow: '0px 5px 5px -3px rgba(0,0,0,0.2), 0px 8px 10px 1px rgba(0,0,0,0.14)',
			'&:hover': {
				background: theme.palette.grey[100],
			},
			...btnRootBaseStyles
		},
		CATNavBar_linkRoot: {
			...linkRootBaseStyles
		},
		CATNavBar_btnLabel: {
			justifyContent: 'left',
			whiteSpace: 'nowrap'
		},
		CATNavBar_dropdownIconRoot: {
			height: '.8em',
			width: '.8em'
		},
		CATNavBar_menuPaperRoot: {
			borderRadius: '0px',
			backgroundColor: theme.palette.grey[100],
			boxShadow: '0px 5px 5px -3px rgba(0,0,0,0.2), 0px 8px 10px 1px rgba(0,0,0,0.14)',
			color: theme.palette.info.main,
		},
		CATNavBar_menuListRoot: {
			paddingTop: '0px',
			paddingBottom: '0px'
		},
		CATNavBar_parentMenuItemRootFocus: {
			padding: '10px',
			fontSize: '0.9em',
			backgroundColor: alpha(theme.palette.common.black, .08),
			whiteSpace: 'nowrap',
			color: theme.palette.info.main,
		},
		CATNavBar_parentMenuItemRoot: {
			padding: '10px',
			backgroundColor: 'transparent',
			fontSize: '0.9em',
			whiteSpace: 'nowrap',
			'&:focus': {
				backgroundColor: 'transparent'
			},
			color: theme.palette.info.main,
		},
		CATNavBar_menuItemRoot: {
			fontSize: '0.9em',
			padding: '0px',
			color: theme.palette.info.main,
		},
		CATNavBar_linkWrapper: {
			display: 'flex',
			flexDirection: 'column',
			justifyContent: 'center',
			transition: 'background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, border 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
			'&:hover': {
				boxShadow: 'none',
			}
		},
		CATNavBar_linkWrapperVisible: {
			visibility: 'visible'
		},
		CATNavBar_linkWrapperHidden: {
			visibility: 'hidden'
		},
		CATNavBar_popper: {
			zIndex: theme.zIndex.modal,
		},
	});
}

export default styles;
